import { ValidatorFn, Validators } from '@angular/forms';
import { noDigitsValidator } from '@shared/validators/noDigitsValidator';
import { AbstractFormControl } from '../abstract-form-control';

export class CityFormControl extends AbstractFormControl {
  validators: any;
  constructor(
    required: boolean = false,
    disabled: boolean = false,
    private options?: CityOptions
  ) {
    super(required, disabled);

    if (options && options.defaultValue) {
      this.setValue(options.defaultValue);
    } else {
      this.setValue(null);
    }

    this.updateValidators(required, this.options?.maxLength);
  }

  public maxLength: number = 50;

  public get readOnlyCss(): boolean {
    return this.options?.readOnlyCss;
  }

  public get autocompleteLabelField(): string {
    return this.options?.autocompleteLabelField ?? 'localite';
  }

  get hideSuccessMark(): boolean {
    return this.options?.hideSuccessMark;
  }

  public get hideErrorMessages(): boolean {
    return this.options?.hideErrorMessages;
  }

  private updateValidators(required: boolean, maxLength?: number): void {
    const validators: ValidatorFn[] = [noDigitsValidator()];

    if (required) {
      validators.push(Validators.required);
    }

    if (maxLength) {
      this.maxLength = maxLength;
      validators.push(Validators.maxLength(maxLength));
    }

    this.validators = validators;
    super.setValidators(validators);
  }

  protected getValidators(): ValidatorFn[] {
    return this.validators;
  }
}

export interface CityOptions {
  maxLength?: number;
  defaultValue?: any;
  readOnlyCss?: boolean;
  hideSuccessMark?: boolean;
  hideErrorMessages?: boolean;
  autocompleteLabelField?: string;
}
